import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import CreationStartedModal from "./components/CreationStartedModal";
import CreateSoftwareFormStep from "./components/CreateSoftwareFormStep";
import FailedStep from "./components/FailedStep";
import LoadingStep from "./components/LoadingStep";
import SoftwareDetailsStep from "./components/SoftwareDetailsStep";
import "./style.scss";

const SoftwareCreationModal = ({
  createModalOpen,
  fetchData,
  toggleModal,
  t,
  Organization,
}) => {
  const [currentStep, setCurrentStep] = useState("analyze");
  const [prefill, setPrefill] = useState(null);
  const [creationStartedOpen, setCreationStartedOpen] = useState(false);

  useEffect(() => {
    if (createModalOpen) {
      setCurrentStep("analyze");
      setPrefill(null);
    }
  }, [createModalOpen]);

  const formTitle = prefill?.isOwnDevelopment
    ? t("Add Own Development Software")
    : t("Add Standard Software");

  const handleCreated = ({ hasPendingAi }) => {
    fetchData?.();
    toggleModal();
    if (hasPendingAi) {
      setCreationStartedOpen(true);
    }
  };

  return (
    <>
      <Modal
        size="xl"
        isOpen={createModalOpen}
        toggle={toggleModal}
        className={`software-creation-modal ${
          currentStep === "details" ? "software-creation-modal--form" : ""
        }`}
      >
        {currentStep !== "loading" && (
          <ModalHeader toggle={toggleModal}>
            {currentStep === "details" ? formTitle : null}
          </ModalHeader>
        )}
        <ModalBody>
          {currentStep === "analyze" && (
            <SoftwareDetailsStep
              initialValues={prefill}
              t={t}
              toggleModal={toggleModal}
              onAnalyzed={setPrefill}
              onChangeStep={setCurrentStep}
            />
          )}

          {currentStep === "loading" && <LoadingStep t={t} />}

          {currentStep === "failed" && (
            <FailedStep t={t} onRetry={() => setCurrentStep("analyze")} />
          )}

          {currentStep === "details" && (
            <CreateSoftwareFormStep
              t={t}
              organization={Organization}
              prefill={prefill}
              onBack={() => setCurrentStep("analyze")}
              onCreated={handleCreated}
              toggleModal={toggleModal}
            />
          )}
        </ModalBody>
      </Modal>

      <CreationStartedModal
        isOpen={creationStartedOpen}
        onClose={() => setCreationStartedOpen(false)}
        t={t}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  Organization: state.Organization,
});

export default withNamespaces()(connect(mapStateToProps)(SoftwareCreationModal));
